import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody, Row, Col, Button } from 'reactstrap';
import { GiSpeaker } from 'react-icons/gi';
import { MdVideocam } from 'react-icons/md';

const AppointmentTypeModal = ({
  title = 'What type of appointment would you like?',
  subText = 'You can select either an audio or a video call with the clinician',
  selected_AP_Type = '',
  cancelBtnHandler,
  confirmBtnHandler,
  isNewCasePage,
  ...restProps
}) => {
  const { t } = useTranslation('common');
  const [btnSelected, setBtnSelected] = useState('');

  useEffect(() => {
    if (!isNewCasePage) {
      setBtnSelected(selected_AP_Type);
    }
  }, [selected_AP_Type]);

  return (
    <Modal centered size="lg" {...restProps} backdrop={'static'} keyboard={false}>
      <ModalBody>
        <Row>
          <Col className="vl-flex-col-center">
            <div style={styles.header}>{title}</div>
            <div style={styles.subText}>{subText}</div>
            <div className="vl-flex-row-center" style={styles.body}>
              <Button
                className={btnSelected === 'AUDIO' ? 'vl-button-icon-outline-selected' : 'vl-button-icon-outline'}
                type="button"
                style={styles.btn}
                onClick={() => setBtnSelected('AUDIO')}
                data-testid="audio-call-type-button"
              >
                <span className="vl-flex-row-center">
                  <GiSpeaker size={26} className="vl-gap-right-small" />
                  {t('Audio Call')}
                </span>
              </Button>
              <Button
                className={btnSelected === 'VIDEO' ? 'vl-button-icon-outline-selected' : 'vl-button-icon-outline'}
                type="button"
                onClick={() => setBtnSelected('VIDEO')}
                data-testid="video-call-type-button"
              >
                <span className="vl-flex-row-center">
                  <MdVideocam size={26} className="vl-gap-right-small" />
                  {t('Video Call')}
                </span>
              </Button>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="vl-flex-row-end">
              <Button
                style={styles.btnGray}
                type="button"
                onClick={cancelBtnHandler}
                data-testid="cancel-choose-call-type-modal-button"
              >
                {t('Cancel')}
              </Button>
              <Button
                style={styles.btnMain}
                type="button"
                disabled={btnSelected === ''}
                onClick={() => confirmBtnHandler(btnSelected)}
                data-testid="confirm-call-type-button"
              >
                {t('Confirm')}
              </Button>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export { AppointmentTypeModal };

const styles = {
  btnMain: {
    width: '110px',
    backgroundColor: 'var(--productPrimary)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productPrimary)',
    color: 'var(--productPrimaryDark)'
  },
  btnGray: {
    width: '110px',
    backgroundColor: 'var(--productGray)',
    fontSize: '14px',
    padding: '4px 10px',
    borderColor: 'var(--productGray)',
    marginRight: '10px'
  },
  header: { color: 'var(--productPink)', fontSize: '30px', fontWeight: 'bold' },
  subText: {
    color: 'var(--productPrimaryDark)',
    fontSize: '14px',
    marginTop: '30px',
    marginBottom: '30px'
  },
  body: { marginBottom: '50px' },
  btn: { marginRight: '30px' }
};
